<template>
    <el-select v-model="value[name]" multiple clearable filterable placeholder="请选择" :disabled="disabled">
        <el-option
                v-for="item in list"
                :key="item.code"
                :label="item.name"
                :value="item.code">
        </el-option>
    </el-select>
</template>
<script>
    export default {
        data() {
            return {
                list: [],
            }
        },
        props: {
            title: {default: "请选择"},
            code: {default: ""},
            name: {default: ""},
            value: null,
            disabled: {default: false}
        },
        methods: {
            findList() {
                this.axiosPost("/sysType/findList.do", {code: this.code}, function (resData) {
                    this.list = resData.list;
                });
            }
        },
        mounted() {
            this.findList();
        },
        watch: {
//            param: {
//                handler(newObj, oldObj) {
//                    this.pageNumber = 1;
//                    this.finished = false;
//                    this.$set(this, "list",[]) ;
//                }, deep: true
//            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/kc/keTemp/sysTypeList.vue